import React, { useContext } from "react"

import Warning from "../../images/icons/wdn-warning.png"
import { GlobalAuthContext } from "../../context/authContext"
import getCountryData from "../../utils/get-country-data"

const ErrorBlock = ({ errors }) => {

  const {state} = useContext(GlobalAuthContext)
  const current_country_data = getCountryData(
    state?.config?.country,
    state?.profile?.country
  )
  return (
    <div className="alert-block mb-4 d-flex align-items-center">
      <img src={Warning} className="mr-3" alt="wdn-warning" />
      {errors?.title
        ? "Title field is required."
        : errors?.no_of_employees
        ? "No of Candidates should be valid integer."
        : errors?.industry_id
        ? errors?.industry_id?.[0]
        : errors?.gender_id
        ? "Gender is required."
        : errors?.preferred_location_id
        ? errors?.preferred_location_id?.[0]
        : errors?.min_salary
        ? `Min expected salary is ${current_country_data?.currency} ${current_country_data?.minSalary}`
        : errors?.max_salary
        ? "Max expected salary should not be less than min salary"
        : errors?.job_type_id
        ? errors?.job_type_id?.[0]
        : errors?.job_shift_id
        ? errors?.job_shift_id?.[0]
        : errors?.education_level_id
        ? "Education field is required."
        : errors?.address
        ? "Address field is required."
        : errors?.end_date
        ? errors?.end_date?.[0]
        : errors?.skills
        ? "Skills field should not be empty."
        : errors?.success
        ? errors?.success
        : errors?.job_description
        ? errors?.job_description
        : ""}
    </div>
  )
}

export default ErrorBlock
